export const DEFAULT_CHART_FONT_SIZE = 12.5;

export function getChartFontSize(override?: number): number {
  return override ?? DEFAULT_CHART_FONT_SIZE;
}
